// v16.17 Phase C.40 — Admin sonner toast listener cho publisher battery.
// v17.10 — Migrated to WS Multiplex Hub. Subscribe channel
// `admin:publisher-battery`. Chỉ mount khi user có role admin (hub tự
// enforce ACL server-side; FE cũng gate để tránh subscribe thừa).
import { useEffect } from "react";
import { toast } from "sonner";
import { subscribe as wsSubscribe } from "../lib/wsHub";

const ADMIN_ROLES = ["super_admin", "admin", "organizer"];

function bandTitle(band, level) {
  const iconMap = { LOW: "🟠", CRITICAL: "🔴", EMERGENCY: "⚫" };
  const labelMap = {
    LOW: "Pin thấp",
    CRITICAL: "Pin rất thấp",
    EMERGENCY: "Pin cực thấp — sắp tắt!",
  };
  const icon = iconMap[band] || "🔋";
  const label = labelMap[band] || "Cảnh báo pin";
  return `${icon} ${label} (${level}%)`;
}

function bandVariant(band) {
  return band === "EMERGENCY" || band === "CRITICAL" ? "error" : "warning";
}

export default function useAdminBatteryToastListener(user) {
  const isAdmin = !!user && Array.isArray(user.roles)
    && user.roles.some((r) => ADMIN_ROLES.includes(r));

  useEffect(() => {
    if (!isAdmin) return undefined;

    const unsub = wsSubscribe("admin:publisher-battery", (msg) => {
      if (!msg || msg.type !== "publisher_battery_alert") return;
      const title = bandTitle(msg.band, msg.level);
      const parts = [];
      if (msg.device_name) parts.push(`📱 ${msg.device_name}`);
      if (msg.court_name) parts.push(`🏟 ${msg.court_name}`);
      if (msg.tournament_name) parts.push(`🏆 ${msg.tournament_name}`);
      if (msg.session_match_code) parts.push(`🎾 ${msg.session_match_code}`);
      parts.push(msg.is_charging ? "🔌 Đang sạc (?)" : "🪫 Không sạc");
      const desc = parts.join(" · ");
      const opts = {
        description: desc,
        duration: msg.band === "EMERGENCY" ? 30000 : 15000,
        id: `battery-${msg.user_id}-${msg.band}`,
      };
      const variant = bandVariant(msg.band);
      if (variant === "error") toast.error(title, opts);
      else toast.warning(title, opts);
    });

    return () => { unsub(); };
  }, [isAdmin]);
}
